














import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Button } from '@/components/Base';
import { Modal } from '@/components/Shared';
import { InvitationBox } from '@/components/InvitationBox';

@Component({
  components: {
    Button,
    InvitationBox,
    Modal,
  },
})
export default class NewProductBar extends Vue {
  @Getter public isNewProductModalDisplayed: boolean;

  public openNewProductModal() {
    this.$store.dispatch('toggleNewProductModal', true);
  }

  public handleModalCloseClick() {
    this.$store.dispatch('toggleNewProductModal', false);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewProductBar/NewProductBar.vue